module.exports = __webpack_public_path__ + "static/media/45.fecd0205.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/45.png
// module id = 617
// module chunks = 0